<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">常見問題 / 常見問題設定</b-col>
      <b-col>
        <div class="text-right">
          <b-btn class="btn btn-ptc1" v-b-toggle.collapse1 v-if="clickTab===1">查詢</b-btn>
        </div>
      </b-col>
    </b-row>
    <div id="func-content">
      <div class="contact-page">
        <div class="col-lg-12">
          <b-card class="bg-warning-card">
            <div class="row">
              <b-tabs class="col-lg-12">
                <b-tab title="常見問題管理" active @click="clickQaTab">
                  <div class="row mt-3"></div>
                  <!--查詢條件-->
                  <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
                    <b-card class="bg-default-card">
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="p-4 box-shadow" header="Form Elements">
                            <div class="row">
                              <label class="control-label col-md-2">分類：</label>
                              <div class="col-md-3">
                                <select class="form-control" v-model="query.categroyID">
                                  <option value="">全部</option>
                                  <option v-for="x in categoryList" v-bind:value="x.categoryId" :key="x.categoryId">{{x.categoryName}}</option>
                                </select>
                              </div>
                            </div>
                            <div class="row mt-3">
                              <label class="control-label col-md-2">問題：</label>
                              <div class="col-md-3">
                                <input type="text" class="form-control" placeholder="請輸入關鍵字查詢" v-model="query.question">
                              </div>
                            </div>
                            <div class="row mt-3">
                              <label class="control-label col-md-2">答案：</label>
                              <div class="col-md-3">
                                <input type="text" class="form-control" placeholder="請輸入關鍵字查詢" v-model="query.answer">
                              </div>
                              <div class="col-md-3">
                                <button type="button" class="btn btn-warning text-white" @click="loadQaPage(1)">查詢</button>
                                <button type="reset" class="btn btn-warning text-white" @click="reset">重設</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card>
                  </b-collapse>
                  <!--清單列表-->
                  <div>
                    <div class="row">
                      <div class="col-lg-12 mb-3">
                        <b-card class="bg-warning-card">
                          <div class="table-responsive">
                            <div class="text-right">
                              <router-link :to="{ name: 'qa_add' }" class='btn btn-outline-light' v-if="FunctionPermission > 1">新增</router-link>
                            </div>
                            <table id="mytable" class="table table-bordred table-striped table-break">
                              <thead class="text-nowrap">
                                <tr>
                                  <th class="mt-3" width="15%">分類</th>
                                  <th class="mt-3" width="25%">問題</th>
                                  <th class="mt-3" width="25%">答案</th>
                                  <th class="mt-3" width="10%">異動人員</th>
                                  <th class="mt-3" width="15%">異動時間</th>
                                  <th class="mt-3" width="10%"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="item in dataList" :key="item.QAID">
                                  <td class="mt-3">{{item.type}}</td>
                                  <td class="mt-3">{{item.question}}</td>
                                  <td class="mt-3">{{item.answer}}</td>
                                  <td class="mt-3">{{item.updatedName}}</td>
                                  <td class="mt-3">{{item.updatedAt}}</td>
                                  <td class="mt-3">
                                    <router-link :to="{ name: 'qa_edit', params: { data: item , categoryList: categoryList,ToPage: pageInfo.currentPage, categroyID: query.categroyID, queryQ: query.question, queryA: query.answer } }" class='btn-circle btn-circle-ptc1' tag="button" v-if="FunctionPermission > 1"><i class="fas fa-pencil-alt" title="編輯"></i></router-link>
                                    <button class="btn-circle btn-circle-ptc1" @click="showDelModal(item.QAID, item.question)" v-if="FunctionPermission > 1"><i class="fas fa-trash-alt" title="刪除"></i></button>
                                    <button class="btn-circle btn-circle-ptc1" @click="showDetailModel(item)"><i class="fas fa-search-plus" title="明細"></i></button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="row" style="padding: 0 1rem">
                            <b-pagination size="md" :total-rows="pageInfo.totalRows" v-model="pageInfo.currentPage" :per-page="pageInfo.pageRows" @change="loadQaPage"></b-pagination>
                            <label style="margin:8px">{{pageInfo.startRowNum}}到{{pageInfo.endRowNum}}，總共 {{pageInfo.totalRows}}筆</label>
                          </div>
                        </b-card>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="分類設定" @click="clickTypeTab">
                  <div class="row mt-3"></div>
                  <b-card class="bg-default-card">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="table-responsive">
                          <!--新增修改分類設定-->
                          <div class="float-right">
                            <table>
                              <tr>
                                <td v-show="!this.btn_add" colspan="3">
                                  <label>{{this.category.oldName}}</label>
                                </td>
                              </tr>
                              <tr class="float-right">
                                <td v-show="!this.btn_add">
                                  <label>{{isTypeUpd === 1 ? '新增' : '修改' }} 分類名稱(限{{limitCategoryCnt}}字)：</label>
                                </td>
                                <td v-show="!this.btn_add">
                                  <input type="text" class="form-control" v-model="category.name" :maxlength="limitCategoryCnt" placeholder="請輸入分類名稱">
                                </td>
                                <td>
                                  <button type="button" class="btn btn-outline-light" v-show="btn_add" @click="addAppTypeBy" v-if="FunctionPermission > 1">新增分類</button>
                                  <button type="button" class="btn btn-save" v-show="!btn_add" @click="openCheckModel(0)">儲存</button>
                                  <button type="button" class="btn btn-clear" v-show="!btn_add" @click="editAppTypeCancel">取消</button>
                                </td>
                              </tr>
                            </table>
                          </div>
                          <!--常見問題分類清單列表-->
                          <table id="AppTypeTable" class="table table-bordred table-striped table-break">
                            <thead>
                              <tr>
                                <th width="85%">APP分類</th>
                                <th width="15%"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="item in categoryList" :key="item.categoryId">
                                <td>{{item.categoryName}}</td>
                                <td>
                                  <button class="btn-circle btn-circle-ptc1" v-if="FunctionPermission > 1" @click="editAppTypeBy(item)"><i class="fas fa-pencil-alt" title="編輯"></i></button>
                                  <button class="btn-circle btn-circle-ptc1" v-if="item.categoryQty <= 0 && FunctionPermission > 1" @click="openDelTypeModel(item)"><i class="fas fa-trash-alt" title="刪除"></i></button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="row" style="padding: 0 1rem">
                          <label style="margin:8px">{{categoryStartRowNum}}到{{categoryEndRowNum}}，總共 {{categoryEndRowNum}}筆</label>
                        </div>
                        <b-modal ref="delAppType" hide-footer title="刪除APP分類">
                          <div class="d-block text-center" style="margin-bottom: 12px;">
                            確認刪除「{{delCategory.name}}」?
                          </div>
                          <div class="d-block text-right">
                            <b-btn variant="primary" @click="delAppTypeSave">確定</b-btn>
                            <b-btn variant="secondary" @click="delCancel">取消</b-btn>
                          </div>
                        </b-modal>
                        <b-modal ref="checkModel" hide-footer :title="modelTitle + 'APP分類'">
                          <div class="d-block text-center" style="margin-bottom: 12px;">
                            確認{{modelTitle}}「{{checkTypeName}}」?
                          </div>
                          <div class="d-block text-right">
                            <b-btn variant="primary" @click="editAppTypeSave()">確定</b-btn>
                            <b-btn variant="secondary" @click="cancelCheckModel">取消</b-btn>
                          </div>
                        </b-modal>
                      </div>
                    </div>
                  </b-card>
                </b-tab>
              </b-tabs>
            </div>
            <div class="row">
              <b-modal ref="modelQA" hide-footer title="明細">
                <b-container fluid>
                  <form>
                    <div class="row mb-3">
                      <label class="control-label col-md-3">分類：</label>
                      <div class="col-md-7">
                        <select class="form-control" disabled v-model="detail.typeId">
                          <option value="">全部</option>
                          <option v-for="x in categoryList" v-bind:value="x.categoryId" :key="x.categoryId">{{x.categoryName}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <label class="control-label col-md-3">問題：</label>
                      <div class="col-md-7">
                        <textarea v-model="detail.question" disabled rows="3" class="form-control resize_vertical" placeholder="請輸入問題" required></textarea>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <label class="control-label col-md-3">答案：</label>
                      <div class="col-md-7">
                        <textarea v-model="detail.answer" rows="7" disabled class="form-control resize_vertical" placeholder="請輸入答案" required></textarea>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <label class="control-label col-md-3">異動人員：</label>
                      <div class="col-md-7">
                        <input type="text" disabled class="form-control" v-model="detail.updatedName">
                      </div>
                    </div>
                    <div class="row mb-3">
                      <label class="control-label col-md-3">異動時間：</label>
                      <div class="col-md-7">
                        <input type="text" disabled class="form-control" v-model="detail.updatedAt">
                      </div>
                    </div>
                    <div class="float-right">
                      <b-btn variant="secondary" @click="cancelDetailModal">關閉</b-btn>
                    </div>
                  </form>
                </b-container>
              </b-modal>
              <b-modal ref="delModelQA" hide-footer title="刪除常見問題">
                <div class="d-block text-center" style="margin-bottom: 12px;">
                  確認刪除，問題：「{{del_qa.Question}}」?
                </div>
                <div class="d-block text-right">
                  <b-btn variant="primary" @click="Delete()">確定</b-btn>
                  <b-btn variant="secondary" @click="cancelDelModal">取消</b-btn>
                </div>
              </b-modal>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { API_URL } from '../../store/root.js'
import miniToastr from 'mini-toastr'
// function
import { getFunctionPermission } from '../../js/LoginUserFunction.js'
miniToastr.init()
export default {
  name: 'qaSetting',
  data () {
    return {
      clickTab: 1, // 1:常見問題管理，2:分類設定=
      /* ====常見問題管理相關==== */
      query: {
        categroyID: '', // 查詢條件-分類
        question: '', // 查詢條件-問題
        answer: '' // 查詢條件-答案
      },
      pageInfo: {
        currentPage: 1,
        totalRows: 0, // 總筆數
        pageRows: 20, // 一頁幾筆
        startRowNum: 0,
        endRowNum: 0
      },
      detail: {
        typeId: '',
        question: '',
        answer: '',
        updatedAt: '',
        updatedName: ''
      },
      del_qa: {
        id: 0,
        Question: ''
      },
      dataList: [], // 常見問題清單
      isQaDel: false,
      /* ====分類設定==== */
      btn_add: true,
      limitCategoryCnt: 8, // 分類名稱限制輸入字數
      categoryList: [], // 分類清單
      categoryStartRowNum: 0,
      categoryEndRowNum: 0,
      category: {
        ID: 0,
        name: '',
        oldName: ''
      },
      checkTypeName: '',
      isTypeUpd: 1,
      modelTitle: '新增',
      delCategory: {
        ID: 0,
        name: ''
      },
      isTypeEdit: false
    }
  },
  components: {},
  created () {
    this.FunctionPermission = getFunctionPermission('F15')
    console.log(this.FunctionPermission)
    // let companyId = localStorage.getItem('COMPANY')
    // console.log('companyId:' + companyId)
    // 分頁處理 : for 第一次進查詢頁 & 從編輯頁跳回來時
    if (this.$route.params.categroyID) {
      this.query.categroyID = this.$route.params.categroyID
    }
    this.query.question = this.$route.params.queryQ
    this.query.answer = this.$route.params.queryA
    if (this.$route.params.ToPage >= 1) {
      this.loadQaPage(this.$route.params.ToPage)
    } else {
      this.loadQaPage(1)
    }
    this.getCategory()
  },
  mounted: function () { },
  methods: {
    /* ====常見問題管理==== */
    /* ====常見問題管理:查詢==== */
    clickQaTab () {
      this.clickTab = 1
      // 若是常見問題分類編輯過後，要重抓
      if (!this.isTypeEdit) { return }
      this.isTypeEdit = false
      this.loadQaPage(this.pageInfo.currentPage)
    },
    loadQaPage: function (currentPage) {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/qa/page/v1', {
        ToPage: currentPage,
        PerPage: this.pageInfo.pageRows,
        QueryType: this.query.categroyID.toString(),
        QueryQ: this.query.question,
        QueryA: this.query.answer
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.dataList = response.data.data
            this.pageInfo.totalRows = (response.data.totalRows === undefined) ? 0 : response.data.totalRows
            this.pageInfo.currentPage = response.data.pageNumber // 分頁處理 : 從編輯頁回列表時，跳回目前分頁
            this.pageInfo.startRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : this.pageInfo.pageRows * (this.pageInfo.currentPage - 1) + 1
            this.pageInfo.endRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : (this.pageInfo.pageRows > response.data.totalRows) ? response.data.totalRows : (this.pageInfo.currentPage * this.pageInfo.pageRows) >= response.data.totalRows ? response.data.totalRows : this.pageInfo.currentPage * this.pageInfo.pageRows
          } else if (response.data.result === '0006') {
            this.$parent.logOut(false, true)
          } else {
            miniToastr.error(response.data.message, '錯誤訊息')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    reset () {
      this.query.categroyID = ''
      this.query.question = ''
      this.query.answer = ''
      this.loadQaPage(1)
    },
    /* ====常見問題管理:明細==== */
    showDetailModel (item) {
      this.detail = item
      this.$refs.modelQA.show()
    },
    cancelDetailModal () {
      this.$refs.modelQA.hide()
    },
    /* ====常見問題管理:刪除==== */
    showDelModal (id, question) {
      this.del_qa.id = id
      this.del_qa.Question = question
      this.$refs.delModelQA.show()
    },
    cancelDelModal () {
      this.$refs.delModelQA.hide()
    },
    Delete () {
      this.$refs.delModelQA.hide()
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/qa/delete', {
        qaID: this.del_qa.id
      })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('刪除常見問題成功')
            this.loadQaPage(this.pageInfo.currentPage)
            this.isQaDel = true
          } else if (response.data.result === '0006') {
            this.$parent.logOut(false, true)
          } else {
            miniToastr.error(response.data.message, '錯誤訊息')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    /* ====分類設定==== */
    getCategory: function () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/qa/categoryquery')
        .then((response) => {
          if (response.data.result === '0000') {
            this.categoryList = response.data.data
            this.categoryStartRowNum = (response.data.data === undefined || response.data.data === null || response.data.data.length === 0) ? 0 : 1
            this.categoryEndRowNum = (response.data.data === undefined || response.data.data === null || response.data.data.length === 0) ? 0 : response.data.data.length
          } else if (response.data.result === '0006') {
            this.$parent.logOut(false, true)
          } else {
            miniToastr.error(response.data.message, '錯誤訊息')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    clickTypeTab () {
      this.clickTab = 2
      this.editAppTypeCancel()
      // 若是常見問題刪除過後，要重抓
      if (!this.isQaDel) { return }
      this.isQaDel = false
      this.getCategory()
    },
    addAppTypeBy () {
      this.btn_add = false
      this.isTypeUpd = 1
      this.category.name = ''
      this.category.oldName = ''
    },
    openCheckModel (delIndex) {
      // 分類名稱未填，不給儲存
      if (this.category.name === '') {
        miniToastr.error('分類名稱未填', '錯誤訊息')
        return false
      }
      if (this.isTypeUpd === 1) {
        this.modelTitle = '新增'
      } else if (this.isTypeUpd === 2) {
        this.modelTitle = '修改'
      }
      this.checkTypeName = this.category.name
      this.$refs.checkModel.show()
    },
    cancelCheckModel () {
      this.$refs.checkModel.hide()
    },
    editAppTypeCancel () {
      this.btn_add = true
      this.category.name = ''
      this.isTypeUpd = 0
    },
    editAppTypeSave () {
      if (!this.btn_add) {
        if (this.isTypeUpd === 1) {
          this.$refs.checkModel.hide()
          this.$parent.Loading = true
          return axios.post(API_URL + '/web/qa/categorycreate', {
            name: this.category.name
          })
            .then((response) => {
              if (response.data.result === '0000') {
                miniToastr.success('新增成功')
                this.getCategory()
                this.clearEditAppType()
              } else if (response.data.result === '0006') {
                this.$parent.logOut(false, true)
              } else {
                miniToastr.error(response.data.message, '錯誤訊息')
              }
              this.$parent.Loading = false
            })
            .catch((error) => {
              miniToastr.error(error, '錯誤訊息')
              this.$parent.Loading = false
            })
        } else if (this.isTypeUpd === 2) {
          this.$refs.checkModel.hide()
          this.$parent.Loading = true
          return axios.post(API_URL + '/web/qa/categoryupdate', {
            categoryId: this.category.ID,
            name: this.category.name
          })
            .then((response) => {
              if (response.data.result === '0000') {
                miniToastr.success('更新成功')
                // 更新名稱
                var idx = this.categoryList.findIndex(x => x.categoryId === this.category.ID)
                this.categoryList[idx].categoryName = this.category.name
                this.categoryList[idx].updatedAt = new Date().toString()
                // 移動第一位
                this.categoryList.unshift(this.categoryList.splice(idx, 1)[0])
                // 初始設定
                this.clearEditAppType()
                this.isTypeEdit = true
              } else if (response.data.result === '0006') {
                this.$parent.logOut(false, true)
              } else {
                miniToastr.error(response.data.message, '錯誤訊息')
              }
              this.$parent.Loading = false
            })
            .catch((error) => {
              miniToastr.error(error, '錯誤訊息')
              this.$parent.Loading = false
            })
        }
      }
    },
    editAppTypeBy (item) {
      this.category.ID = item.categoryId
      if (item.categoryName.length > this.limitCategoryCnt) {
        this.category.name = item.categoryName.substr(0, this.limitCategoryCnt)
      } else {
        this.category.name = item.categoryName
      }
      this.isTypeUpd = 2
      this.category.oldName = '原名稱：' + item.categoryName
      this.btn_add = false
    },
    clearEditAppType () {
      this.btn_add = true
      this.category.ID = 0
      this.category.name = ''
      this.isTypeUpd = 0
      this.checkTypeName = ''
    },
    /* ====常見問題分類設定:刪除==== */
    openDelTypeModel (item) {
      this.delCategory.ID = item.categoryId
      this.delCategory.name = item.categoryName
      this.$refs.delAppType.show()
    },
    delAppTypeSave () {
      this.$refs.delAppType.hide()
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/qa/categorydelete', {
        id: this.delCategory.ID
      })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('刪除成功')
            var idx = this.categoryList.findIndex(x => x.categoryId === this.delCategory.ID)
            this.categoryList.splice(idx, 1)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(false, true)
          } else {
            miniToastr.error(response.data.message, '錯誤訊息')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    delCancel () {
      this.delCategory.ID = 0
      this.delCategory.name = ''
      this.$refs.delAppType.hide()
    }
  },
  computed: {
    categoryListByDESC () {
      return this.categoryList.slice().sort(function (a, b) {
        return a.updatedAt < b.updatedAt
      })
    }
  }
}

</script>

<style scoped>
#mytable > tbody > tr > td {
  vertical-align: middle;
}

.table-break {
  word-break: break-all;
  /* table-layout:fixed; */
}

.text-nowrap > th {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/qa/qaSetting.vue